/** v1 silver datasources replaced by blueprint consolidation on Retsinformation. */
export const DEPRECATED_SILVER_CONSOLIDATION_DATASOURCES = [
  "konsolideret",
  "consolidation",
] as const;

export function isDeprecatedSilverConsolidationDatasource(
  datasource: string | undefined
): boolean {
  if (!datasource) return false;
  const normalized = datasource.trim().toLowerCase();
  return DEPRECATED_SILVER_CONSOLIDATION_DATASOURCES.some(
    (value) => value === normalized
  );
}

/** Composite legacy ids use anchor:change-law; Retsinformation browse uses the anchor. */
export function resolveRetsinformationAccessionFromDocumentId(
  documentId: string
): string {
  const colonIndex = documentId.indexOf(":");
  if (colonIndex === -1) return documentId;
  return documentId.slice(0, colonIndex);
}
